module.exports = __webpack_public_path__ + "static/edit-product-custom-badges-7a188ab72b3541f68c2ef78e954c7660.png";